<script setup lang="ts">
  interface PopoverProps {
    isOpen: boolean
  }

  withDefaults(defineProps<PopoverProps>(), {
    isOpen: false,
  })

  const { t } = useI18n()

  const themeOptions = [
    { label: t('Automatic'), value: 'system' },
    { label: t('Light'), value: 'light' },
    { label: t('Dark'), value: 'dark' },
  ]

  const { theme, updateTheme } = useTheme()
  const themeComputed = computed({
    get: () => theme.preference,
    set: (value: ColorThemeOption) => {
      updateTheme(value)
    },
  })

  const contentDisplaySettingsStore = useContentDisplaySettingsStore()
  const { featureFlags } = storeToRefs(contentDisplaySettingsStore)

  const { articleSummary, updateArticleSummary } = useUserSettings(featureFlags)
  const articleSummaryComputed = computed({
    get: () => articleSummary.isEnabled,
    set: (value) => {
      updateArticleSummary(value)
    },
  })
</script>
<template>
  <div
    class="absolute bg-background-default bottom-11 flex ml-[-20%] sm:w-[80vw] min-w-[120px] max-w-[348px] flex-col gap-6 rounded-lg border-[1px] border-settings_box_border p-6 shadow-[0_4px_8px_rgba(0,0,0,0.14)]"
    :class="{ hidden: !isOpen }"
    data-testid="settings-popover"
    tabindex="0"
  >
    <div class="flex flex-col gap-3">
      <Typography
        variant="text-lg"
        weight="font-semibold"
        color="text-content-primary"
        classes="text-start"
      >
        {{ t('Page Settings') }}
      </Typography>
      <hr class="h-[1px] bg-background-neutral-muted border-0" />
    </div>
    <div class="flex flex-col gap-2">
      <div class="flex flex-col gap-1">
        <Typography
          variant="text-sm"
          weight="font-semibold"
          color="text-content-primary"
          class="m-0 text-left"
        >
          {{ t('Theme') }}
        </Typography>
        <Typography
          variant="text-xs"
          class="m-0 text-left text-content-secondary"
        >
          {{
            t(
              'Customize your preferred theme with Dark, Light, or Auto Mode options.'
            )
          }}
        </Typography>
      </div>

      <SettingsThemeSwitch v-model="themeComputed" :options="themeOptions" />
    </div>
    <hr
      v-if="articleSummary.showSettingsToggle"
      class="h-[1px] bg-background-neutral-muted border-0"
    />
    <div v-if="articleSummary.showSettingsToggle" class="flex flex-row gap-4">
      <Typography
        variant="text-sm"
        weight="font-semibold"
        color="text-content-primary"
        class="m-0 text-left flex-grow"
      >
        {{ t('AI News Summaries') }}
      </Typography>
      <ToggleSwitch v-model="articleSummaryComputed" />
    </div>
  </div>
</template>
